<template>
  <div :class="subscriptionName">
    {{ subscriptionName }}
  </div>
</template>

<script>
export default {
  name: "SubscriptionBadge",
  props: {
    type: {
      type: String,
      required: true,
    }
  },

  computed: {
    subscriptionName() {
      return this.type || 'free';
    }
  }
}
</script>

<style lang="scss" scoped>
div {
  display: inline-block;
  padding: 0 25px;
  border-radius: 20px;
  font-weight: 800;
  font-size: 10px;
  color: #fff;
  line-height: 26px;
  height: 26px;
  text-transform: uppercase;
}
.pro {
  background-color: #40bd5e;
}
.extreme {
  background-color: #ad6bce;
}

.gold {
  background-color: #ffbe00;
}
.free {
  height: 30px;
  font-weight: 600;
  font-size: 22px;
  color: #595959;
  padding: 0;
}
</style>
